const translations = {
  app: {
    company: 'Quicq',
    title: 'Dashboard',
    searchBar: {
      search: {
        label: 'Search',
        placeholder: 'Search',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      dashboard: 'Overview',
      notifications: 'Notifications',
      picker: 'Picker',
      spooler: 'Spooler',
      user: 'User',
      userMenu: {
        signOut: 'Sign out',
      },
      notificationsMenu: {
        none: 'No notifications',
        all: 'All notifications',
      },
    },
    navigation: {
      main: {
        overview: 'Overview',
        auditLog: 'Activity log',
        users: 'Users',
        profile: 'My profile',
      },
    },
  },
  pages: {
    auditLog: {
      title: 'Activity log',
      logProps: {
        method: 'Action',
        resource: 'Source',
        user: 'User',
        timestamp: 'Date',
      },
    },
    oauthClients: {
      title: 'Oauth clients',
      create: {
        button: 'Add',
        title: 'New oauth client',
      },
    },
    users: {
      title: 'Users',
      create: {
        title: 'New user',
        button: 'Add',
      },
    },
  },
  dataGrid: {
    selection: {
      button: {
        all: 'All',
      },
      selected: '{count} selected',
    },
    pagination: {
      currentPageLabel: 'Page {page}',
      displayedRows: '{from}-{to} of {count}',
      rowsPerPage: 'Rows per page:',
    },
    columnSelection: {
      selectedColumns: 'Column selection',
      availableColumns: 'Available columns',
      title: 'Columns',
    },
    filterSelection: {
      title: 'Filters',
    },
  },
  formFields: {
    searchUser: {
      placeholder: 'Search for a user',
    },
  },
  actions: {
    add: 'Add',
    cancel: 'Cancel',
    delete: 'Delete',
    filter: 'Filter',
    goToList: 'Show all',
    save: 'Save',
  },
  filter: {
    showLogsWhere: 'Show logs where',
    selectAnOption: 'Select an option...',
    equals: 'Is equal to',
    chipContent: {
      equals: '{filter} equals {option}',
    },
  },
  pagination: {
    pageNumber: 'Page {i}',
  },
  properties: {
    name: 'Name',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email address',
    formula: 'Formula',
    oauthClientName: 'Client name',
    redirectUri: 'Redirect uri',
    grantTypes: 'Grant types',
    scopes: 'Scopes',
    oauthClientSecret: 'Client secret',
    oauthClientSecretTooltip: 'Copied client secret',
    oauthClientID: 'Client ID',
    oauthClientIDTooltip: 'Copied client ID',
  },
  errors: {
    validation: {
      empty: '{target} can not be empty',
    },
  },
};

export default translations;
